import React from 'react';
import { string } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// Import components
import { PlayerElements as Player } from 'components/elements';
import { PacketsModal } from 'components/views/payment/packets';
import { CommonButton } from 'components/views/vod/components/buttons/CommonButton';

// Import styles
import { ButtonWrapper } from './styles';

// Import utilities
import { ToggleRPC, Portal } from 'components/utilities';

// Import variables
import { PLAYER_SELECTORS } from 'helpers/variables';

const { PLAYER } = PLAYER_SELECTORS;

const ProductPackets = ({ playerType, message }) => {
	const { t } = useTranslation();
	const playerState = useSelector((state) => state[playerType]);

	return (
		<>
			<Player.IconLock />
			<Player.ErrorHeading>{message}</Player.ErrorHeading>

			<ToggleRPC>
				{({ on, toggle }) => (
					<>
						<ButtonWrapper>
							<CommonButton onButtonClick={toggle}>
								{t(`vod_buttons_check_availability_product`)}
							</CommonButton>
						</ButtonWrapper>
						{on && (
							<Portal>
								<PacketsModal toggle={toggle} uuid={playerState?.productUuid} />
							</Portal>
						)}
					</>
				)}
			</ToggleRPC>
		</>
	);
};

ProductPackets.defaultProps = {
	playerType: PLAYER
};

ProductPackets.propTypes = {
	playerType: string,
	message: string
};

export default ProductPackets;
